module.exports = __webpack_public_path__ + "static/media/0026.078fe593.jpg";